export default "__VITE_ASSET__d1bf0d97__"